<template>
  <v-flex>
    <v-layout row wrap class="mx-40">
      <v-flex sm6 md6 lg6>
        <h2 class="title mb-2" style="margin-top: 28px;">Notifications</h2>
      </v-flex>
      <v-flex
        sm6
        md6
        lg6
        class="text-xs-right text-lg-right text-md-right"
        style="margin-top: 32px;"
      >
        <div class="mb-2 ml-3 timezone">Timezone: {{ timeZone }}</div>
      </v-flex>
    </v-layout>
    <div v-if="subscriptionHistory.length > 0">
      <v-layout row wrap class="mx-40 top-line">
        <v-flex sm6 md6 lg6 class="pl-0"> {{ pendingCount }} new </v-flex>
        <v-flex
          sm6
          md6
          lg6
          class="text-md-right text-xs-right text-sm-right pr-0"
        >
          <IconBase
            icon-name="Mark all as read"
            :width="12"
            :height="12"
            :view-box="'0 0 12 12'"
            style="margin-bottom: 0px !important; margin-right: 4px;"
          >
            <MarkReadLightIcon v-if="themeMode === 'light'" />
            <MarkReadDarkIcon v-else />
          </IconBase>
          <a href="#" class="mark-all-read" @click.prevent="mark_all_read">
            Mark all as read
          </a>
        </v-flex>
      </v-layout>
      <v-container
        id="scroll-target"
        style="max-height: 250px; margin-top: 36px !important; padding-top: 0px; padding-bottom: 0px;"
        class="scroll-y"
      >
        <v-list v-scroll:#scroll-target="onScroll" dense>
          <template v-for="(item, key) in notifications">
            <v-list-tile :key="key" avatar class="my-1">
              <v-list-tile-avatar
                size="22"
                :tile="true"
                style="min-width: 34px;"
              >
                <IconBase v-if="themeMode === 'light'">
                  <ReadMailIcon v-if="item.is_read" />
                  <UnreadMailIcon v-else />
                </IconBase>
                <IconBase v-else>
                  <ReadMailDarkIcon v-if="item.is_read" />
                  <UnreadMailDarkIcon v-else />
                </IconBase>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title style="white-space: normal;">
                  <div
                    :class="item.is_read ? 'read-message' : 'unread-message'"
                  >
                    <span class="unread"
                      >{{
                        item.mutation_log.match(/^(?:\w+\.?\s+){3}/) != null &&
                        item.mutation_log.match(/^(?:\w+\.?\s+){3}/)[0]
                          ? item.mutation_log.match(/^(?:\w+\.?\s+){3}/)[0]
                          : ""
                      }}
                    </span>
                    <span>{{
                      item.mutation_log.replace(/^(?:\w+\.?\s+){3}/, "")
                    }}</span>
                  </div>
                </v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-list-tile-action-text>
                  <div
                    :class="['action-message', item.is_read ? '' : 'unread']"
                  >
                    {{ item.ts_utc | formatDateAgo }}
                  </div>
                </v-list-tile-action-text>
                <div class="mt-2">
                  <a
                    href="#"
                    @click.prevent="
                      item.is_read === 0
                        ? mark_read(item.ts_utc, 1)
                        : mark_read(item.ts_utc, 0)
                    "
                  >
                    <IconBase
                      v-if="themeMode === 'light'"
                      :icon-name="item.is_read === 0 ? 'Mark as read' : ''"
                    >
                      <ReadMailCircleLightIcon v-if="item.is_read" />
                      <UnreadMailCircleLightIcon v-else />
                    </IconBase>
                    <IconBase
                      v-else
                      :icon-name="item.is_read === 0 ? 'Mark as read' : ''"
                    >
                      <ReadMailCircleDarkIcon v-if="item.is_read" />
                      <UnreadMailCircleDarkIcon v-else />
                    </IconBase>
                  </a>
                </div>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider class="mx-3"></v-divider>
          </template>
        </v-list>
      </v-container>
    </div>
    <div
      v-else
      style="height: 300px; text-align: center; display: flex; justify-content: center;"
    >
      <div style="margin: auto;">
        <div>
          <img
            :src="
              '/img/notifications_bell_' +
                (themeDark ? 'dark' : 'light') +
                '.svg'
            "
            alt="Notifications"
          />
        </div>
        <div class="no-notifications">
          You haven't received any notifications yet
        </div>
      </div>
    </div>
  </v-flex>
</template>
<style scoped>
.mx-40 {
  margin-right: 40px !important;
  margin-left: 40px !important;
}
>>> .v-list__tile__action {
  min-width: 86px;
}
.theme--light .no-notifications {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  color: #8691a4;
}
>>> .theme--light .v-list__tile {
  padding: 0 0 0 16px;
  height: 100%;
}
>>> .theme--light .v-list__tile__title {
  height: 100%;
}
.theme--light.v-divider {
  border-color: #e5efff;
}
.theme--light .timezone {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  color: #8691a4;
}
.theme--light h2.title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px !important;
  line-height: 26px !important;
  color: #103a84;
}
.theme--light .top-line {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #103a84;
}
.theme--light .empty-list {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  color: #103a84;
}
.theme--light .read-message {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #7395d0;
}
.theme--light .unread-message {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #0757e0;
}
.theme--light .unread-message .unread {
  font-weight: bold;
}
.theme--light .action-message {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  color: #8691a4;
}
.theme--light .action-message.unread {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  color: #103a84;
}
.theme--light .view-all {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #103a84;
}
.theme--light .mark-all-read {
  text-decoration: none;
  font-size: 13px;
}

/********************/

.theme--dark h2.title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px !important;
  line-height: 26px !important;
}
.theme--dark .top-line {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #e9e9e9;
}
.theme--dark .empty-list {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  color: #e9e9e9;
}
.theme--dark .read-message {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: rgba(235, 235, 245, 0.6);
}
.theme--dark .unread-message {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 130%;
  color: #639bfb;
}
.theme--dark .unread-message .unread {
  font-weight: bold;
}
.theme--dark .action-message {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  color: rgba(235, 235, 245, 0.6);
}
.theme--dark .action-message.unread {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  color: #e9e9e9;
}
.theme--dark .view-all {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #e9e9e9;
}
.theme--dark .mark-all-read {
  color: #e9e9e9 !important;
  text-decoration: none;
  font-size: 13px;
}
.theme--dark.v-divider {
  border-color: #303030;
}
.theme--dark .timezone {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  color: rgba(235, 235, 245, 0.6);
}
>>> .theme--dark .v-list__tile {
  padding: 0 0 0 16px;
  height: 100%;
}
>>> .theme--dark .v-list__tile__title {
  height: 100%;
}
.theme--dark .no-notifications {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  color: #959596;
}
</style>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import swal from "sweetalert2";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";
import IconBase from "../icons/IconBase";
import ReadMailIcon from "../icons/ReadMailIcon";
import ReadMailDarkIcon from "../icons/ReadMailDarkIcon";
import UnreadMailIcon from "../icons/UnreadMailIcon";
import UnreadMailDarkIcon from "../icons/UnreadMailDarkIcon";

import UnreadMailCircleDarkIcon from "../icons/UnreadMailCircleDarkIcon";
import UnreadMailCircleLightIcon from "../icons/UnreadMailCircleLightIcon";
import ReadMailCircleDarkIcon from "../icons/ReadMailCircleDarkIcon";
import ReadMailCircleLightIcon from "../icons/ReadMailCircleLightIcon";

import MarkReadLightIcon from "../icons/MarkReadLightIcon";
import MarkReadDarkIcon from "../icons/MarkReadDarkIcon";

export default {
  components: {
    IconBase,
    ReadMailIcon,
    UnreadMailIcon,
    ReadMailDarkIcon,
    UnreadMailDarkIcon,
    UnreadMailCircleDarkIcon,
    UnreadMailCircleLightIcon,
    ReadMailCircleDarkIcon,
    ReadMailCircleLightIcon,
    MarkReadLightIcon,
    MarkReadDarkIcon
  },
  data: () => ({
    accountHistoryDialog: false,
    page: 0
  }),
  created: function() {
    this.$store.dispatch("auth/refreshUserHistory");
  },
  methods: {
    onScroll(e) {
      if (e.target.scrollTop + 250 >= e.target.scrollHeight) {
        this.page = this.page + 1;
      }
    },
    onClosePopup: function(data) {
      if (data.hasOwnProperty("close") && data.close === true) {
        this.accountHistoryDialog = false;
      }
    },
    openHistoryDialog: async function() {
      this.accountHistoryDialog = true;
    },
    mark_read: function(ts_utc, is_read) {
      axios
        .post("/api/v1/subscriptions/history/read/", {
          ts_utc: ts_utc,
          is_read: is_read
        })
        .then(response => {
          if (response.status === 200) {
            if (response.data.status === true) {
              this.$store.dispatch("auth/refreshUserHistory");
              return true;
            }
          }
          this.infoAlert("Oops...", "Something went wrong! Please try again.");
          return false;
        })
        .catch(error => {
          this.infoAlert("Oops...", "Something went wrong! Please try again.");
          return false;
        });
    },
    mark_all_read: function() {
      axios
        .post("/api/v1/subscriptions/history/read_all/")
        .then(response => {
          if (response.status === 200) {
            if (response.data.status === true) {
              this.$store.dispatch("auth/refreshUserHistory");
              return true;
            }
          }
          this.infoAlert("Oops...", "Something went wrong! Please try again.");
          return false;
        })
        .catch(error => {
          this.infoAlert("Oops...", "Something went wrong! Please try again.");
          return false;
        });
    },
    infoAlert: async function(title, text) {
      await swal({
        title: title,
        html: text,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: this.themeDark ? "swal-type-info-dark" : "swal-type-info"
      });
    }
  },
  computed: {
    ...mapGetters({
      subscriptionHistory: "auth/userHistory",
      themeDark: "settings/darkmode"
    }),
    themeMode: function() {
      return this.themeDark ? "dark" : "light";
    },
    pendingCount: function() {
      return this.subscriptionHistory.filter(function(item) {
        return !item.is_read;
      }).length;
    },
    notifications: function() {
      return this.subscriptionHistory.slice(0, 50 * (this.page + 1));
    },
    timeZone: function() {
      return moment()
        .tz(moment.tz.guess())
        .format("z");
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/dashboard/RecentAccountHistory.vue